import { useAuth0 } from "@auth0/auth0-react";
import { callbackUri } from "src/auth.config";
// import { WidgetContext } from "src/contexts/WidgetContext";
import { useNavigate } from "react-router";

//Custom Hook to handle doLogOut
export const useDoLogout = () => {
  const { logout } = useAuth0();
  const navigate = useNavigate();
  //Get function resetAppState to reset app
  // const { resetAppState } = useContext(WidgetContext);

  const doLogOut = async () => {
    //Function to reset all sessions and states in app
    // resetAppState();
    await logout({
      logoutParams: {
        returnTo: callbackUri, 
      },
    });
  };
  return doLogOut;
};

export default useDoLogout;
